'use client';
import { useTranslation } from '@/lib/i18n';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Loader2 } from 'lucide-react';

export default function ChatStatusModal() {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      sx={{
        '& .MuiDialog-paper': { backgroundColor: '#171717', color: '#fff' },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            width: 200,
          }}
        >
          <Loader2 className="animate-spin" />
          <span>{t('Creating chat')}...</span>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
